import { render, staticRenderFns } from "./info-group-select.vue?vue&type=template&id=764e5552&"
import script from "./info-group-select.vue?vue&type=script&lang=js&"
export * from "./info-group-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports